import { Component, Input, OnInit } from '@angular/core';

import { formatUtcToLocal } from '../../../util/date-util';
import { formatClasses } from '../../../columns/column-definition/set-filter-helpers';

@Component({
  selector: 'app-selected-order',
  templateUrl: './selected-order.component.html',
  styleUrls: ['./selected-order.component.scss'],
  standalone: false,
})
export class SelectedOrderComponent implements OnInit {
  @Input() public paramData!: any;
  protected regions: any;
  protected classes: any;
  protected clientReference: any;
  protected trademarkName: any;
  protected dateShared!: string;

  ngOnInit(): void {
    this.trademarkName = this.paramData?.trademarkName;
    this.clientReference = this.paramData?.clientReference;
    this.classes = formatClasses({ value: this.paramData.classes });
    this.formatRegions();
    this.setFirstSharedDate();
  }

  private formatRegions(): void {
    this.regions = this.paramData.regions
      .filter((region: any) => region !== null && region !== undefined)
      .sort((a: any, b: any) => {
        const labelA = a.label ?? '';
        const labelB = b.label ?? '';
        return labelA.localeCompare(labelB);
      })
      .map((r: any) => r.label + (r.limited ? ' (Limited)' : ''))
      .filter((label: any) => label.trim() !== '')
      .join(', ');
  }

  private setFirstSharedDate(): void {
    const list = this.paramData?.sharedRecipientDetailsList;

    if (!Array.isArray(list) || list.length === 0) {
      this.dateShared = '';
      return;
    }

    const validEntries = list.filter(
      (entry: any) =>
        entry?.dateShared && !isNaN(new Date(entry.dateShared).getTime()),
    );

    if (validEntries.length === 0) {
      this.dateShared = '';
      return;
    }

    const firstShare = validEntries.reduce((oldest: any, current: any) =>
      new Date(current.dateShared).getTime() <
      new Date(oldest.dateShared).getTime()
        ? current
        : oldest,
    );

    const formatted = formatUtcToLocal(firstShare?.dateShared);
    this.dateShared = this.extractDate(formatted);
  }

  private extractDate(dateStr?: string): string {
    if (!dateStr || !dateStr.includes(', ')) {
      return '';
    }

    const parts = dateStr.split(', ');
    const datePart = parts[1];

    if (!datePart) {
      return '';
    }

    const [day, month, year] = datePart.split(' ');

    if (!day || !month || !year) {
      return '';
    }

    return `${day}-${month.toUpperCase()}-${year}`;
  }
}
